import React from 'react'
import { db } from '..'
import { ref, update } from 'firebase/database'

const ArchivedGames = ({userData}) => {

    // 参加ゲームリストにアーカイブしたゲームを追加する関数
    const backToJoinedGame = async (gameId) => {
        try {
            // 現在の参加ゲームリストを安全に取得（配列として扱う）
            const currentJoinedGames = Array.isArray(userData.joinedGames) 
                ? userData.joinedGames 
                : (userData.joinedGames ? Object.values(userData.joinedGames) : []);
            
            // 現在のアーカイブリストを安全に取得
            const currentArchivedGames = Array.isArray(userData.archivedGames) 
                ? userData.archivedGames 
                : [];

            // 参加ゲームリストに追加（重複チェック）
            const updatedJoinedGames = currentJoinedGames.includes(gameId) 
                ? currentJoinedGames 
                : [...currentJoinedGames, gameId];
            
            // アーカイブリストから削除
            const updatedArchivedGames = currentArchivedGames.filter(game => game.gameId !== gameId);

            // Firebaseのusersに参加ゲームリストを更新
            const userRef = ref(db, 'users/' + userData.uid);
            await update(userRef, {
                joinedGames: updatedJoinedGames,
                archivedGames: updatedArchivedGames
            });

            console.log("Game restored successfully:", gameId);
            alert("ゲームが復元されました。");
            
            // ページをリロードして最新の状態を反映
            window.location.reload();
        } catch (error) {
            console.error("Error restoring game:", error);
            alert("ゲームの復元に失敗しました。もう一度お試しください。");
        }
    };

    // 作成ゲームリストにアーカイブした作成ゲームを追加する関数
    const backToCreatedGame = async (gameId) => {
        try {
            // 現在の作成ゲームリストを安全に取得（配列として扱う）
            const currentCreatedGames = Array.isArray(userData.createdGames) 
                ? userData.createdGames 
                : (userData.createdGames ? Object.values(userData.createdGames) : []);
            
            // 現在のアーカイブリストを安全に取得
            const currentArchivedCreatedGames = Array.isArray(userData.archivedCreatedGames) 
                ? userData.archivedCreatedGames 
                : [];

            // 作成ゲームリストに追加（重複チェック）
            const updatedCreatedGames = currentCreatedGames.includes(gameId) 
                ? currentCreatedGames 
                : [...currentCreatedGames, gameId];
            
            // アーカイブリストから削除
            const updatedArchivedCreatedGames = currentArchivedCreatedGames.filter(game => game.gameId !== gameId);

            // Firebaseのusersに作成ゲームリストを更新
            const userRef = ref(db, 'users/' + userData.uid);
            await update(userRef, {
                createdGames: updatedCreatedGames,
                archivedCreatedGames: updatedArchivedCreatedGames
            });

            console.log("Created game restored successfully:", gameId);
            alert("作成ゲームが復元されました。");
            
            // ページをリロードして最新の状態を反映
            window.location.reload();
        } catch (error) {
            console.error("Error restoring created game:", error);
            alert("作成ゲームの復元に失敗しました。もう一度お試しください。");
        }
    };

  return (
    <div className='p-3 max-w-5xl mx-auto pt-6 mb-3'>
        
        <h1 className='text-2xl text-gray-800 text-center mb-6'><i className="bi bi-archive me-2"></i>アーカイブしたゲーム</h1>

        {/* 参加したゲームのアーカイブ */}
        <div className="mb-8">
            <h2 className='text-lg text-gray-700 mb-4'><i className="bi bi-people-fill me-2"></i>参加したゲーム</h2>
            { userData?.archivedGames?.length > 0 ? (
                <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4'>
                    {/* とりあえずゲームIDのみ表示 */}
                    {userData.archivedGames.map((game, index) => (
                        <div key={index} className='bg-white shadow-sm rounded-lg p-4 border'>
                            <p className='text-sm text-gray-500'>ゲームID: {game.gameId}</p>
                            <h3 className='text-lg font-semibold mb-2'>{game.name}</h3>
                            {/* アーカイブから戻すボタン */}
                            <button className='mt-2 bg-purple-500 hover:bg-purple-600 text-white px-4 py-2 rounded-md text-sm' onClick={() => backToJoinedGame(game.gameId)}>
                                <i className='me-1 bi bi-arrow-counterclockwise'></i>復元
                            </button>
                        </div>
                    ))}
                </div>
            ) : (
                <p className='text-center text-gray-500 py-4'>アーカイブした参加ゲームはありません。</p>
            )}
        </div>

        {/* 作成したゲームのアーカイブ */}
        <div className="mb-8">
            <h2 className='text-lg text-gray-700 mb-4'><i className="bi bi-gear-fill me-2"></i>作成したゲーム</h2>
            { userData?.archivedCreatedGames?.length > 0 ? (
                <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4'>
                    {userData.archivedCreatedGames.map((game, index) => (
                        <div key={index} className='bg-white shadow-sm rounded-lg p-4 border'>
                            <p className='text-sm text-gray-500'>ゲームID: {game.gameId}</p>
                            <h3 className='text-lg font-semibold mb-2'>{game.name}</h3>
                            {/* アーカイブから戻すボタン */}
                            <button className='mt-2 bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-md text-sm' onClick={() => backToCreatedGame(game.gameId)}>
                                <i className='me-1 bi bi-arrow-counterclockwise'></i>復元
                            </button>
                        </div>
                    ))}
                </div>
            ) : (
                <p className='text-center text-gray-500 py-4'>アーカイブした作成ゲームはありません。</p>
            )}
        </div>
    </div>
  )
}

export default ArchivedGames